import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { StatisticsPeriod } from './statistics-period.model';
import { ChargingStatistics } from './charging-statistics-model';
import { StationChargingStatistics } from './station-charging-statistics-model';
import { StationGroupChargingStatistics } from './stationgroup-charging-statistics-model';

@JsonObject()
export class OverAllChargingStatistics {
  @JsonProperty('Period') period: StatisticsPeriod;
  @JsonProperty('TotalConsumption') totalConsumption: number;
  @JsonProperty('AverageConsumption') averageConsumption: number;
  @JsonProperty('TotalTimeSpentSeconds') totalTimeSpentSeconds: number;
  @JsonProperty('AverageTimeSpentSeconds') averageTimeSpentSeconds: number;
  @JsonProperty('TotalEarnings') totalEarnings: number;
  @JsonProperty('TotalHubjectEarnings') totalHubjectEarnings: number;
  @JsonProperty('AverageEarnings') averageEarnings: number;
  @JsonProperty('AverageHubjectEarnings') averageHubjectEarnings: number;
  @JsonProperty('TotalChargings') totalChargings: number;
  @JsonProperty('TotalHubjectChargings') totalHubjectChargings: number;
  @JsonProperty({ name: 'ByDay', type: ChargingStatistics }) byDay: Array<ChargingStatistics>;
  @JsonProperty({ name: 'ByStation', type: StationChargingStatistics }) byStation: Array<StationChargingStatistics>;
  @JsonProperty({ name: 'ByStationGroup', type: StationGroupChargingStatistics }) byStationGroup: Array<StationGroupChargingStatistics>;
}
